import React from 'react';

const ProductImgFallbackIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#c5ccdb"
        strokeWidth="1.5"
        strokeLinecap="round"
    >
        <rect x="3" y="3" width="18" height="18" rx="3" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <polyline points="21 15 16 10 5 21" />
    </svg>
);

export default ProductImgFallbackIcon;